// Mirror of Shared/Calculators/MulchCalculator.cs.
import type { CalcDef, ResultLine } from "../types.js";
import * as F from "../format.js";

const fields: CalcDef["fields"] = [
  { key: "areaLengthFt", kind: "number", default: 10, min: 0.5, max: 500 },
  { key: "areaWidthFt", kind: "number", default: 10, min: 0.5, max: 500 },
  { key: "depthIn", kind: "number", default: 3, min: 0.5, max: 24 },
  {
    key: "bagSize",
    kind: "select",
    defaultChoice: "2cuft",
    choices: [
      { value: "2cuft", set: { bagCuFt: 2.0 } },
      { value: "1.5cuft", set: { bagCuFt: 1.5 } },
      { value: "0.5cuft", set: { bagCuFt: 0.5 } },
    ],
  },
  { key: "wastePct", kind: "number", default: 5, min: 0, max: 25 },
  { key: "pricePerBag", kind: "number", default: 4, min: 0, max: 50 },
];

function compute(i: Record<string, number>): Record<string, number> {
  const l = F.get(i, "areaLengthFt");
  const w = F.get(i, "areaWidthFt");
  const depth = F.get(i, "depthIn");
  const bagCuFt = F.get(i, "bagCuFt");
  const waste = F.get(i, "wastePct");
  const price = F.get(i, "pricePerBag");

  const volCuFt = l * w * (depth / 12);
  const volWithWaste = volCuFt * (1 + waste / 100);
  const cuYards = volWithWaste / 27;
  const bags = bagCuFt > 0 ? F.ceilUnits(volWithWaste / bagCuFt) : 0;
  const cost = bags * price;

  return {
    volCuFt: F.round(volCuFt, 2),
    volWithWaste: F.round(volWithWaste, 2),
    cuYards: F.round(cuYards, 2),
    bags,
    cost: F.round(cost, 2),
  };
}

function present(_i: Record<string, number>, r: Record<string, number>): ResultLine[] {
  const bags = F.get(r, "bags");
  return [
    { label: "Volume", value: `${F.dec(F.get(r, "volCuFt"))} cu ft` },
    { label: "Cubic yards", value: `${F.dec(F.get(r, "cuYards"))} cu yd` },
    { label: "Bags to buy", value: `${F.intStr(bags)} ${F.plural(bags, "bag", "bags")}`, highlight: true },
    { label: "Est. materials cost", value: F.usd(F.get(r, "cost")), sub: "rough — material only, bagged pricing" },
  ];
}

export const mulch: CalcDef = { slug: "mulch-calculator", fields, compute, present };
